import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';

interface UnionStatusSelectorProps {
  value: string | undefined;
  onChange: (value: string) => void;
}

export function UnionStatusSelector({ value, onChange }: UnionStatusSelectorProps) {
  return (
    <div className="space-y-2">
      <Label>Union Status</Label>
      <RadioGroup value={value || ''} onValueChange={onChange}>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="union" id="union" />
          <Label htmlFor="union" className="font-normal cursor-pointer">
            Union
          </Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="non_union" id="non_union" />
          <Label htmlFor="non_union" className="font-normal cursor-pointer">
            Non-Union
          </Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="merit_shop" id="merit_shop" />
          <Label htmlFor="merit_shop" className="font-normal cursor-pointer">
            Merit Shop
          </Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="mixed" id="mixed" />
          <Label htmlFor="mixed" className="font-normal cursor-pointer">
            Mixed
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
}